export default {"src":"/_next/static/media/number-persons.9e727894.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};